module.exports = __webpack_public_path__ + "static/media/cacShrimpGrits.7dbe2da4.jpg";